export default __webpack_public_path__ + "static/media/mixkit-guitar-notification-alert-2320.2459515d.mp3";